import { cnpjMask, phoneMask } from '../../../../utils/masks-constants';
import { VALID_CNPJ_INPUT_CHAR_REGEX } from '../../../../utils/cnpj-utils';
import { IInputSettings } from './IInputSettings';

const IS_VALID_NUMBER_REGEX = /\d/;
const IS_VALID_DECIMAL_WITH_TWO_PLACES = /^(\d{0,3})(,\d{1,2})?$/;

export const GetDefaultSettings = (): IInputSettings => {
    return {
        maxlength: 100,
        getValue(value) {
            return value;
        },
    } as IInputSettings;
};

export const GetCnpjSettings = (): IInputSettings => {
    return {
        maxlength: 18,
        onBeforeInput(event: any) {
            const inputChar = event.data;

            if (!inputChar) {
                return;
            }

            if (!VALID_CNPJ_INPUT_CHAR_REGEX.test(inputChar)) {
                event.preventDefault();
            }
        },
        getValue(value: any) {
            return cnpjMask(value);
        },
        onPaste(event: any) {
            event.preventDefault();
            const pastedText = event.clipboardData?.getData('text') ?? '';
            const sanitizedValue = pastedText
                .replaceAll(/[^A-Z0-9]/gi, '')
                .slice(0, 14);
            const input = event.target as HTMLInputElement;
            const nativeInputValueSetter = Object.getOwnPropertyDescriptor(
                HTMLInputElement.prototype,
                'value',
            )?.set;

            nativeInputValueSetter?.call(input, sanitizedValue);
            input.dispatchEvent(new Event('input', { bubbles: true }));
        },
    } as IInputSettings;
};

export const GetPhoneSettings = (): IInputSettings => {
    return {
        maxlength: 15,
        getValue(value) {
            return phoneMask(value);
        },
    } as IInputSettings;
};

export const GetInputNumberSettings = (maxLength?: number): IInputSettings => {
    const checkMaxLength = (event: any) => {
        if (
            maxLength &&
            IS_VALID_NUMBER_REGEX.test(event.currentTarget.value)
        ) {
            const value = `${event.currentTarget.value}${event.data}`;
            if (value.length > maxLength) {
                event.preventDefault();
            }
        }
    };

    return {
        minValue: 0,
        onBeforeInput(event: any) {
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            !IS_VALID_NUMBER_REGEX.test(event.data) && event.preventDefault();
            checkMaxLength(event);
        },
        getValue(value) {
            return value;
        },
    } as IInputSettings;
};

export const GetInputDecimalWithTwoPlaces = (): IInputSettings => {
    const separator = ',';

    const checkDecimalWithTwoPlaces = (event: any) => {
        if (
            event.data === separator &&
            event.currentTarget.value.includes(separator)
        ) {
            event.preventDefault();
        }

        const value = `${event.currentTarget.value}${event.data}`;

        if (
            !IS_VALID_DECIMAL_WITH_TWO_PLACES.test(value) &&
            !value.endsWith(separator)
        ) {
            event.preventDefault();
        }
    };

    return {
        onBeforeInput(event: any) {
            if (
                !IS_VALID_NUMBER_REGEX.test(event.data) &&
                event.data !== separator
            ) {
                event.preventDefault();
            }

            checkDecimalWithTwoPlaces(event);
        },
        getValue(value) {
            return value;
        },
    } as IInputSettings;
};

export const GetLoadInput = (): IInputSettings => {
    return {
        getValue(value) {
            return value.replaceAll(/[^a-zA-Z0-9 ,;]/g, '');
        },
    } as IInputSettings;
};
